import { Stack } from '@mui/material';

import {
  MetricBarChart,
  MetricCardProps,
  MetricPanel,
  MetricTimePoint,
} from '@occc/ui-design-system';

type RetailerNetworkLoyaltyPerformanceProps = {
  totalMetrics: MetricCardProps[];
  loyaltyMetrics: MetricCardProps[];
  salesMetrics: MetricCardProps[];
  transactionsTimeSeries: MetricTimePoint[];
};

export const RetailerNetworkLoyaltyPerformance = ({
  totalMetrics,
  loyaltyMetrics,
  salesMetrics,
  transactionsTimeSeries,
}: RetailerNetworkLoyaltyPerformanceProps) => {
  return (
    <Stack gap={1} mb={8}>
      <MetricPanel metrics={totalMetrics}>
        <MetricBarChart metrics={transactionsTimeSeries} />
      </MetricPanel>
      <MetricPanel title='Loyalty' metrics={loyaltyMetrics} />
      <MetricPanel title='Sales Volume' metrics={salesMetrics} />
    </Stack>
  );
};
